import React, { useEffect, useState } from "react";
import { http } from "@/context/AuthContext";
import { Loader2, FileText, UploadCloud } from "lucide-react";

export default function PortalDocuments() {
  const [items, setItems] = useState([]);
  const [config, setConfig] = useState({ drive_enabled: false });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    Promise.all([
      http.get("/portal/documents"),
      http.get("/config"),
    ]).then(([d, c]) => {
      setItems(d.data);
      setConfig(c.data);
    }).finally(() => setLoading(false));
  }, []);
  return (
    <div data-testid="portal-documents">
      <h1 className="text-4xl">My Documents</h1>
      <p className="mt-2 text-navy/65">Securely access and exchange files with the ConnectHer team.</p>

      <div className="mt-6 card p-6 bg-navy text-soft">
        <div className="flex items-start gap-4">
          <UploadCloud className="w-6 h-6 text-gold flex-shrink-0" />
          <div className="flex-1">
            <h4 className="text-lg text-soft">Document Storage</h4>
            <p className="text-sm text-soft/70 mt-1">
              {config.drive_enabled
                ? "Connected to your Google Drive. Files you upload here are stored in your personal ConnectHer folder."
                : "Document upload is currently being set up. Once your admin connects Google Drive, you'll be able to upload files directly from here."}
            </p>
          </div>
        </div>
      </div>

      <div className="mt-8">
        {loading ? (
          <div className="flex items-center gap-2 text-navy/60"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>
        ) : items.length === 0 ? (
          <div className="card p-10 text-center">
            <FileText className="w-10 h-10 text-gold mx-auto" />
            <h3 className="mt-3 text-2xl">No documents yet.</h3>
            <p className="mt-2 text-navy/65">Once you and the team start exchanging files, they'll appear here.</p>
          </div>
        ) : (
          <ul className="card divide-y divide-navy/5">
            {items.map((doc, i) => (
              <li key={i} className="p-5 flex items-center justify-between" data-testid={`document-${i}`}>
                <div>
                  <div className="text-navy font-medium">{doc.name}</div>
                  <div className="text-xs text-navy/55">{doc.created_at?.slice(0, 10)}</div>
                </div>
                {doc.url && (
                  <a href={doc.url} target="_blank" rel="noreferrer" className="text-sm text-gold hover:underline">Open</a>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
